<template>
  <SummaryPanel title="Main Engine" :badges="badges" :anchor-id="anchorId">
    <div v-if="rpmEngines.length" class="panel-mini-row main-engine-gauges">
      <div v-for="engine in rpmEngines" :key="engine.key" class="main-engine-gauge">
        <div class="main-engine-gauge-ring">
          <RadialGaugeChart
            class="main-engine-gauge-chart"
            :value="engine.rpm"
            :max="1600"
            label="RPM"
            color="#0084ff"
            width="146px"
            height="146px"
            :show-labels="false"
          />
          <div class="main-engine-gauge-value">{{ formatNum(engine.rpm, 2) }}</div>
        </div>
        <div class="panel-caption">{{ engine.label }} RPM</div>
      </div>
    </div>

    <div class="panel-mini-row main-engine-donuts">
      <div v-if="fuelItems.length" class="panel-mini-row main-engine-donut">
        <DonutChart
          :data="fuelItems"
          label-key="label"
          value-key="raw"
          :colors="fuelColors"
          :width="96"
          :height="96"
          :show-legend="false"
        />
        <DonutLegend title="Fuel" :items="fuelItems" :colors="fuelColors" />
      </div>
      <div v-if="runningItems.length" class="panel-mini-row main-engine-donut">
        <DonutChart
          :data="runningItems"
          label-key="label"
          value-key="raw"
          :colors="runningColors"
          :width="96"
          :height="96"
          :show-legend="false"
        />
        <DonutLegend title="Running" :items="runningItems" :colors="runningColors" />
      </div>
    </div>
  </SummaryPanel>
</template>

<script>
import { formatNum } from '@/util/number';
import { toDuration } from '@/util/date';
import SummaryPanel from './SummaryPanel.vue';
import DonutLegend from './DonutLegend.vue';
import DonutChart from '../charts/DonutChart.vue';
import RadialGaugeChart from '../charts/RadialGaugeChart.vue';

export default {
  name: 'MainEnginePanel',
  components: {
    SummaryPanel,
    DonutLegend,
    DonutChart,
    RadialGaugeChart,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      fuelColors: ['#fd7e14', '#0dcaf0', '#ffc107', '#6610f2', '#d63384', '#198754'],
      runningColors: ['#20c997', '#6f42c1', '#0d6efd', '#dc3545', '#795548', '#607d8b'],
    };
  },
  computed: {
    rpmEngines() {
      return this.model.engines.filter((e) => e.rpm !== null);
    },
    fuelItems() {
      return this.model.engines
        .filter((e) => (e.fuelLiters || 0) > 0)
        .map((e) => ({
          label: e.label, raw: e.fuelLiters, value: `${formatNum(e.fuelLiters, 2)} L`, share: e.fuelShare,
        }));
    },
    runningItems() {
      return this.model.engines
        .filter((e) => (e.runningSeconds || 0) > 0)
        .map((e) => ({
          label: e.label, raw: e.runningSeconds, value: toDuration(e.runningSeconds),
        }));
    },
  },
  methods: {
    formatNum,
  },
};
</script>

<style src="./summaryPanel.css"></style>

<style scoped>
.main-engine-gauges {
  justify-content: space-around;
}

.main-engine-gauge {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ring apex cuma ~76% lebar chart, jadi chart 146px digeser biar ring pas 120x100 */
.main-engine-gauge-ring {
  position: relative;
  width: 120px;
  height: 100px;
}

.main-engine-gauge-chart {
  position: absolute;
  left: -13px;
  top: -16px;
  width: 146px;
  height: 120px;
}

/* angka di tengah ring (pusat y 56px) */
.main-engine-gauge-value {
  position: absolute;
  left: 0;
  right: 0;
  top: 56px;
  transform: translateY(-50%);
  text-align: center;
  font-size: 16.8px;
  font-weight: 600;
  color: #000;
  pointer-events: none;
}

.main-engine-donuts {
  margin-top: 8px;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.main-engine-donut {
  flex: 1 1 0;
  min-width: 0;
  flex-wrap: nowrap;
  gap: 10px;
}

.main-engine-donut > :first-child {
  flex: none;
}

/* panel sempit: legend pindah ke bawah donut */
@media (max-width: 1199.98px) {
  .main-engine-donut {
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
}

/* HP: grup numpuk, legend balik ke samping */
@media (max-width: 575.98px) {
  .main-engine-donuts {
    flex-wrap: wrap;
  }

  .main-engine-donut {
    flex-basis: 100%;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
}
</style>
